export default __webpack_public_path__ + "locales/de/DeleteProfileEverDialog.json?hash=490e252c976848f3761edd3f33a187c9";